import type { AdditionalSpaceObservingSession, RoomObservingSession } from './visit-counsel.types';

/**
 * 방/추가공간 옵저빙에서 짐 단계가 끝났다고 볼 수 있는지.
 * (`buildCounselChecklist`의 `movingConfirmed`와 동일 — 영상 촬영 액션 노출 기준)
 */
export function hasObservingSessionMovingItemsConfirmed(
  session: RoomObservingSession | AdditionalSpaceObservingSession | null | undefined
): boolean {
  if (!session) return false;
  const st = session.status;
  if (st === 'STARTED' || st === 'COMPLETED') return true;
  /** 스케치에서 넘어온 specId만 있고 세션은 아직 REQUESTED인 경우는 짐 기록 완료로 치지 않음 */
  return (session.movingItems?.length ?? 0) > 0;
}
